// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"CF-z","smallCardRow":"DF-z","largeCardRow":"EF-z","productSearchRow":"FF-z","curatedRow":"GF-z"};